<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2024-03-05 09:24:51
 * @LastEditors: hexy
 * @LastEditTime: 2024-04-10 16:45:13
 * @Description: 配合比维护-查看配合比
 * @FilePath: \ICPSxin\src\views\platform\ICPS\basicConfig\components\lookRatio.vue
-->
<template>
  <div>
    <el-dialog v-dialogDrag :visible.sync="isLookRatioDialog" width="960px" :close-on-click-modal="false" :append-to-body="true" :before-close="resetLookFromDate">
      <span slot="title" class="dialog-title">{{ lookDialogTitle }}</span>
      <div class="dialoginfo">
        <div style="position: relative; margin-bottom: 10px; height: 30px">
          工程名称:{{detailItem.engineeringName}}
          订单号:{{detailItem.code}}
          产品名称:{{detailItem.productName}}
          浇筑部位:{{detailItem.structuralParts}}
        </div>
        <div class="tabtop" :style="{ width: lineList.length * 190 + 'px', marginTop: '30px', marginLeft: '0px' }">
          <div v-for="(item, index) in lineList" :key="index" >
            <div :class="{ active: currentIndex == item.index, activeEnable: currentIndex == item.index && lineList[currentIndex].enable == 0, text: currentIndex != item.index && !(currentIndex == item.index && lineList[currentIndex].enable == 1) }" @click="choose(item)" >{{ item.name }}</div>
          </div>
        </div>
        <!-- <div class="tabtop" :style="{ width: lineList.length * 190 + 'px', marginTop: '30px', marginLeft: '0px' }">
          <div v-for="(item, index) in lineList" :key="index" @click="choose(item)">
            <div :class="currentIndex == item.index ? 'active' : 'text'">{{ item.name }}</div>
          </div>
        </div> -->
        <div style="margin-top: 20px;">
          <div style="margin-bottom: 10px; height: 30px">
            <el-switch
              v-model="lineList[currentIndex].enable"
              class="switch"
              :active-value="1"
              :inactive-value="0"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="启用"
              inactive-text="禁用"
              style="padding-left: 10px"
              width:60
              disabled
            ></el-switch>
            <!-- @change="handleSwitchChange(lineList[currentIndex].enable)" -->
            <span style="margin-left: 45px">搅拌时间:</span>
            <el-input v-model="lineList[currentIndex].mixTime" type="number" style="width: 150px" disabled placeholder="请输入">
              <template slot="append"> s</template>
            </el-input>
          </div>
          <el-table
            ref="multipleTable"
            :header-cell-style="{ background: '#f3f6f9' }"
            :cell-style="cellStyle"
            border
            stripe
            style="width: 100%"
            :data="lineList[currentIndex].mixInfoList"
            tooltip-effect="dark"
        >
          <el-table-column label="原物料" align="center" prop="name" :min-width="160"></el-table-column>
          <el-table-column label="理论用量(kg/m³)" align="center" prop="theoreValue" :min-width="140"></el-table-column>
          <el-table-column label="实际用量(kg/m³)" align="center" prop="theoreValueTrue" :min-width="140"></el-table-column>
          <el-table-column label="偏差(kg)" align="center" prop="deviation" :min-width="140"></el-table-column>
          <el-table-column label="原料库" align="center" prop="rawForm" :min-width="140"></el-table-column>
        </el-table>
        </div>
        
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetLookFromDate">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { queryOneByPlan } from "@/api/basicConfig/mixIssue.js";
import { getPLByStationId } from "@/api/basicConfig/site.js";

export default {
  data() {
    return {
      /*表格增删改查及下载接口*/
      options: [],
      /*表格数据*/
      lookDialogTitle: "查看配合比",
      total: 0,
      tableData: [],
      detailItem: {},
      selectRaw: [],
      lineItem:"",
      currentIndex: 0,
      lineList: [
        {
          mixName: "",
          mixTime: 0,
          lineId: "",
          lineName: "",
          enable: 1,
          mixInfoList: [],
        },
      ],
    };
  },
  props: {
    isLookRatioDialog: {
      type: Boolean,
      default: false,
    },
    Item: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    Item(val) {
      this.detailItem=val
      this.getLineList()
    },
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
  },
  methods: {
    cellStyle() {
      // 定义样式变量
      let cellStyle;
      // 根据每一行的status属性的值进行判断
      // 如果是正常就展示以绿色字体展示，如果是禁用就以红色颜色展示
      if(this.lineList[this.currentIndex].enable == 0){
        cellStyle = "background:#d0d0d0;color: #ffffff;border-right: none;";
        return cellStyle;
      } else {
        cellStyle = "border-right: none;";
        return cellStyle;
      }
      
    },
    choose(item) {
      this.currentIndex = item.index;
      this.lineList[this.currentIndex].lineName = item.name;
      this.lineList[this.currentIndex].lineId = item.id;
    },
    getLineList() {
      getPLByStationId({ stationId: this.detailItem.stationId }).then(res => {
        if (res.code === 1001) {
              if( res.data?.length>0){
                this.lineList = res.data.map((item, index) => ({
                index: index,
                id: item.id,
                name: item.name,
                mixName: "",
                mixTime: 0,
                lineId: item.id,
                lineName:item.name,
                enable: 0,
                mixInfoList: [{ id: "", name: "容重", theoreValue: "", deviation: "" ,theoreValueTrue:"",rawFormId:"" ,rawList:[]}],
              }));
                this.currentIndex = this.lineList[0].index;
                this.queryOneByPlan();
            }else{
              this.$emit("update:isLookRatioDialog", false);
              this.$message.warning("暂无生产线，请先配置生产线")
            }
          }
      });
    },
    queryOneByPlan() {
      let that = this;
      queryOneByPlan({ planId: this.detailItem.id }).then(res => {
        if (res.code === 1001) {
          if (res.data?.length > 0) {
            that.lineList.forEach(item1 => {
              res.data.forEach(item2 => {
                if (item1.id == item2.lineId) {
                  item1.mixInfoList = JSON.parse(item2.mixInfo);
                  let obj = { id: "", name: "容重", theoreValue: item2.theoreValue, deviation: item2.deviation, theoreValueTrue: item2.theoreValueTrue, rawFormId: "", rawList: [] };
                  item1.mixInfoList.push(obj);
                  let index = item1.mixInfoList.findIndex(item => item.name == "容重");
                  if (index == -1) {
                    item1.mixInfoList.push(obj);
                  }
                  item1.planId = that.detailItem.id ;
                  item1.mixName = item2.mixName;
                  item1.mixTime = item2.mixTime;
                  item1.lineId = item2.lineId;
                  item1.lineName = item2.lineName;
                  item1.stationId = this.detailItem.stationId;
                  item1.stationName = this.detailItem.stationName;
                  item1.enable = item2.enable;
                }
              });
            });
            this.isLookRatioDialog = true;
            this.$forceUpdate();
          }
        }
      });
    },
    //主页面添加事件
    async addClick(data) {
      this.detailItem = data;
      this.getLineList();
    },
    resetLookFromDate() {
      this.$emit("update:isLookRatioDialog", false);
      // this.$refs.lookRatio.clearSelection();
    },
    /*保存/修改弹窗*/
  },
};
</script>

<style lang="scss" scoped>
.title_box {
  display: block;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #000000;
  margin-bottom: 10px;
}
.el-form-item__label {
  color: #000000;
  font-size: 14px;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}
.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;

  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;

    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }

    .active {
      width: 189px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .activeEnable {
      width: 189px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: red;
      border-radius: 4px;
    }

    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
</style>
